import React, { useEffect, useState } from 'react'
import { Table, Space, message } from 'antd'
import { useNavigate } from 'react-router-dom'
import pagesService from '../../services/pagesService'
import AdminPageTitle from '../../components/AdminPageTitle/AdminPageTitle'
import { Helmet } from 'react-helmet-async'
import { Page } from '../../services/models'

type Props = {}

const AdminPagesPage: React.FC<Props> = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState<boolean>(false)
  const [data, setData] = useState<Page[]>([])

  const fetchData = () => {
    setLoading(true)
    pagesService.list().then((data) => {
      setData(data.pages)
      setLoading(false)
    }).catch((error) => {
      setLoading(false)
      message.error(error.message)
    })
  }

  useEffect(() => {
    fetchData()
  }, [])

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id'
    },
    {
      title: 'Заголовок',
      dataIndex: 'title',
      key: 'title'
    },
    {
      title: 'URL',
      dataIndex: 'url',
      key: 'url'
    },
    {
      title: 'Действия',
      key: 'actions',
      render: (_: any, record: Page) => (
                <Space size="middle">
                    <a onClick={() => navigate('/pages/' + record.url)}>Просмотр</a>
                    <a onClick={() => navigate('/pages/edit/' + record.id)}>Изменить</a>
                </Space>
      )
    }
  ]

  return (
        <div>
            <Helmet><title>Prisma — Страницы</title></Helmet>
            <AdminPageTitle title={'Страницы'}
                            buttonText={'Новая страница'}
                            onClickButton={() => navigate('/pages/create')}/>

            <Table loading={loading} dataSource={data} columns={columns} rowKey={'id'}/>
        </div>
  )
}

export default AdminPagesPage
